import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAssets = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 21"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 1.713c-1.433 0-2.595 1.142-2.595 2.55 0 .833.407 1.573 1.035 2.038.588.435 1.165 1.024 1.165 1.755 0 .215.177.389.395.389a.39.39 0 0 0 .395-.389c0-.731.577-1.32 1.165-1.756a2.53 2.53 0 0 0 1.034-2.037c0-1.408-1.162-2.55-2.594-2.55m-2.595 9.786c0-1.408 1.162-2.55 2.595-2.55 1.432 0 2.594 1.142 2.594 2.55 0 1.409-1.162 2.55-2.594 2.55-1.433 0-2.595-1.141-2.595-2.55m6.228 1.629c.623.485 1.483.485 2.273.485 1.432 0 2.594 1.142 2.594 2.55s-1.162 2.55-2.595 2.55c-1.432 0-2.594-1.142-2.594-2.55q.002-.382.108-.73c.185-.609.16-1.356-.342-1.747a.384.384 0 0 1-.064-.546.4.4 0 0 1 .556-.063l.064.05Zm-7.266 0c-.623.485-1.483.485-2.273.485-1.432 0-2.594 1.142-2.594 2.55s1.162 2.55 2.594 2.55c1.433 0 2.595-1.142 2.595-2.55a2.5 2.5 0 0 0-.108-.73c-.185-.609-.16-1.356.342-1.747a.384.384 0 0 0 .064-.546.4.4 0 0 0-.555-.063l-.065.05Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAssets;
